import { Injectable } from '@angular/core';

import { DataEntry } from '@osos/shared/api';
import { UserModel } from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

@Injectable()
export class UserParserV1Service extends ParserBase<DataEntry, UserModel> {
  constructor() {
    super(DataEntry, UserModel, 1);
  }
  getPresenterModel(model: DataEntry): UserModel {
    const value = model.value;
    const presenter = {
      specificationVersion: this.version,
      id: model.id,
      creationInfo: model.creationInfo,
      updateInfo: model.updateInfo,
      accountInfo: {
        userName: value.account_information?.username,
        emailAddress: value.account_information.email_address,
      },
      workInfo: { orgUnit: value.work_information?.org_unit },
      basicInfo: {
        firstName: value.basic_info.first_name,
        fullName: value.basic_info.full_name,
        lastName: value.basic_info.last_name,
        phoneNumber: value.basic_info.phone_number,
        birthDate: value.basic_info.birthdate,
        profilePicture: value.basic_info.profile_picture,
        gender: value.basic_info.gender?.[0],
      },
      // @TODO: the following props should be removed later and keep only the mapped props
      value: model.value,
      dataEntity: model.dataEntity,
      state: model.state,
    } satisfies UserModel;

    return presenter;
  }

  getDataModel(presenter: UserModel): DataEntry {
    throw new Error(
      "This function shouldn't be used! Use DataEntryParser instead!",
    );
  }
}
